export default "__VITE_ASSET__Of_x9ypj__"